import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import activeHtml from 'react-active-html'

import './page.css'
import Gallery from './gallery'
import Calendar from './calendar'
import ContactForm from './contactForm'
import Error404 from './error404'

const componentsMap = {
	gallery: props => <Gallery {...props} />,
	calendar: props => <Calendar {...props} />,
	contactform: props => <ContactForm {...props} />,
	error404: props => <Error404 {...props} />,
}

export const Page = ({page}) => <section className="main">
	{page ? activeHtml(page.content, componentsMap) : ''}
</section>

Page.propTypes = {
	page: PropTypes.shape({
		content: PropTypes.string,
	}),
}

Page.defaultProps = {
	page: {
		content: '<error404 />',
	},
}

export const mapStateToProps = ({pages}, {location: {pathname}}) => ({
	page: pages
		.filter(({published}) => published)
		.find(({path}) => path === pathname),
})

const connectedPage = () =>
	<Route path={'/'} component={connect(
		mapStateToProps
	)(Page)} />

export default connectedPage



// WEBPACK FOOTER //
// ./src/components/page.jsx